import { render } from "./LongName.vue?vue&type=template&id=0f00ebf4"
import script from "./LongName.vue?vue&type=script&lang=js"
export * from "./LongName.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__